import { css } from 'styled-components';
import { typeScale } from '../../styles/newTypography';
import { breakpointUp } from '../../styles/mediaUtils';
import { spacing } from '../../styles/newThemeVariables.styles';

export const ListStyles = css`
  color: ${({ theme }) => theme.textPrimary};
  ${typeScale.mobile.body.xs};

  @media ${breakpointUp.tablet} {
    ${typeScale.tablet.body.md}
  }

  @media ${breakpointUp.desktop} {
    ${typeScale.desktop.body.md}
  }

  /* General list styles */
  ol,
  ul {
    margin: 0;
  }

  ul {
    list-style: none;
    padding-left: 0;
  }

  /* List item styles */
  ul li {
    display: flex;
    align-items: start;
    column-gap: ${spacing.space12};
  }

  /* Handle nested paragraphs */
  ol > li > p,
  ul > li > p {
    margin: 0;
  }

  /* Special list item styles */
  ol > li.multiline,
  ul > li.multiline {
    margin-bottom: ${spacing.space8};
  }

  ul > li:last-child,
  ol > li:last-child {
    margin-bottom: ${spacing.space16};
  }

  /* Custom marker for unordered list items */
  ul li::before {
    content: '';
    width: ${spacing.space12};
    min-width: ${spacing.space12};
    max-width: ${spacing.space12};
    margin-top: calc(${spacing.space12} + ${spacing.space2});
    border-bottom: 0.0625rem solid ${({ theme }) => theme.textPrimary};
    display: block;
  }

  ul li::marker {
    font-size: 0;
  }
`;
